//this file is mainly used in Register and ResetPwd frontend pages

export const usernameRules='<b>• Username must be at least 5 characters long<br>• Can contain only letters</b>';

export const emailRules='<b>• Please enter your Email Address</b>';

export const passwordRules='<b>• Password must contain at least 8 characters<br>• For your account security, please choose a password that will be difficult to guess';
